import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Avatar,
  Divider,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import LockResetIcon from "@mui/icons-material/LockReset";
import { useTheme } from "@mui/material/styles";
import { useState, useEffect } from "react";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const Header = ({ open, toggleDrawer }) => {
  const navigate = useNavigate();
  const db = getFirestore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [userData, setUserData] = useState(null);

  const handleProfileMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = async () => {
    await auth.signOut();
    navigate("/login");
  };

  // ✅ Fetch user data from Firestore
  useEffect(() => {
    const fetchUser = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) setUserData(userSnap.data());
    };

    fetchUser();
  }, [db]);

  return (
    <AppBar
      position="fixed"
      elevation={3}
      sx={{
        bgcolor: "#1e293b",
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        transition: "0.3s",
        width: isMobile
          ? "100%"
          : open
          ? `calc(100% - 240px)`
          : `calc(100% - 75px)`,
        ml: isMobile ? 0 : open ? "240px" : "75px",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          px: isMobile ? 1 : 3,
        }}
      >
        {/* Left Section */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton onClick={toggleDrawer} sx={{ color: "#fff", mr: 1 }}>
            <MenuIcon />
          </IconButton>

          <Typography
            variant={isMobile ? "subtitle1" : "h6"}
            sx={{ fontWeight: 600 }}
          >
            VISWASEVA VIDYAMANDIR
          </Typography>
        </Box>

        {/* Right Section */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {!isMobile && (
            <Typography sx={{ mr: 1, fontSize: 15 }}>
              Welcome {userData?.username || "User"} 👋
            </Typography>
          )}

          <IconButton onClick={handleProfileMenu}>
            <Avatar
              sx={{
                width: isMobile ? 30 : 36,
                height: isMobile ? 30 : 36,
                bgcolor: "#ff6600",
              }}
            >
              {(userData?.name || "A").charAt(0).toUpperCase()}
            </Avatar>
          </IconButton>

          {/* Dropdown Menu */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              sx: { width: 220 },
            }}
          >
            <Box sx={{ p: 2, textAlign: "center" }}>
              <Avatar sx={{ bgcolor: "#ff6600", margin: "0 auto" }}>
                {(userData?.name || "A").charAt(0).toUpperCase()}
              </Avatar>
              <Typography variant="body1" sx={{ fontWeight: 600, mt: 1 }}>
                {userData?.name}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                {userData?.role || "User"}
              </Typography>
            </Box>

            <Divider />

            <MenuItem
              onClick={() => {
                handleClose();
                navigate("/change-password");
              }}
            >
              <LockResetIcon sx={{ mr: 1 }} /> Change Password
            </MenuItem>

            <Divider />

            <MenuItem
              onClick={handleLogout}
              sx={{ color: "#d32f2f", fontWeight: 600 }}
            >
              <LogoutIcon sx={{ mr: 1 }} /> Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
